module.exports = __webpack_public_path__ + "static/media/work-day-scheduler.94c5435a.jpg";